@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.item-quantity-in-shipments {
  display: flex;
  min-height: 80px;

  &.editable {
    .current-quantity {
      border-left: 0;
      border-radius: 0 4px 4px 0;
    }
  }
}

.section {
  text-align: center;
  min-height: 80px;
}

.section-title {
  font-size: 11px;
  font-weight: @bold;
  color: @item-quantity-in-shipments--title--text-color;
  line-height: 12px;
  height: 12px;
  white-space: nowrap;
}

.editable-section {
  border-radius: 4px 0 0 4px;
  padding: 10px 15px;
  background: @item-quantity-in-shipments--editable--background-color;

  .section-title {
    color: @item-quantity-in-shipments--editable--text-color;
    margin-bottom: 10px;
    opacity: 0.8;
  }
}

.current-quantity {
  border: 1px solid @item-quantity-in-shipments--current--border-color;
  background: @item-quantity-in-shipments--current--background-color;
  border-radius: 4px;
  padding: 10px;

  &.totally-shipped {
    border: 1px solid @item-quantity-in-shipments--totally-shipped--border-color;
    background: @item-quantity-in-shipments--totally-shipped--background-color;
  }

  &.big-number {
    b {
      font-size: 20px;
    }
  }

  .section-content {
    color: @item-quantity-in-shipments--current-section--text-color;
    line-height: 48px;
    font-size: 16px;
    font-weight: @bold;
  }

  b {
    color: @item-quantity-in-shipments--current-section-bold--text-color;
    margin: 0 5px;
    font-size: 22px;
  }
}
